<template>
  <div class="container">
    <div class="banner"></div>
    <div
      style="width: 980px; margin: 30px auto"
      v-for="item in imgurls"
      :key="item.id"
    >
      <el-image :src="item.url" :z-index="1"></el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      carousel_img: [
        { id: 10001, url: require("./img/lb1.jpg") },
        { id: 10002, url: require("./img/lb2.jpg") },
        { id: 10003, url: require("./img/lb3.jpg") },
      ],
      imgurls: [
        { id: 1001, url: require("./img/a.jpg") },
        { id: 1002, url: require("./img/b.jpg") },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.container {
  box-sizing: border-box;
  width: 100vw;
  .banner {
    width: 100%;
    height: 550px;
    background-image: url("./img/lb1.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 150px;
      margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n + 1) {
      background-color: #d3dce6;
    }
  }
}
</style>
